let userTransDone = true;              
let pendingAIDeltas = [];

export function handleServerEvent(event, context = {}) {
    const {
      setCandSpeaking,
      setIntvSpeaking,
      updatePromptJson,
      setMessageItems,
    } = context;
  
    if (!event.type) {
      console.error("[Realtime] 🔴 No event type provided");
      return;
    }
  
    switch (event.type) {
      case "session.created": {
        console.log("[Realtime] 🔌 Session created");
        break;
      }
  
      case "session.updated": {
        console.log("[Realtime] 🔌 Session updated");
        break;
      }
  
      case "input_audio_buffer.speech_started": {
        console.log("[Realtime] 🧍‍♂️ User started speaking");
        setCandSpeaking?.(true);
        setIntvSpeaking?.(false);
        userTransDone = false;
      
        setMessageItems((prev) => {
          const last = prev[prev.length - 1];
          const shouldAdd = !(last?.role === "user" && last?.text === "Transcribing...");
          
          if (shouldAdd) {
            return [
              ...prev,
              {
                role: "user",
                text: "Transcribing...",
                timestamp: new Date().toLocaleTimeString(),
                streaming: true,
              },
            ];
          }
          return prev;
        });
      
        break;
      }
      
  
      case "input_audio_buffer.speech_stopped": {
        console.log("[Realtime] 🧍‍♂️ User stopped speaking");
        setCandSpeaking?.(false);
        break;
      }
  
      case "response.created": {
        console.log("[Realtime] 🤖 Assistant started responding");
        setIntvSpeaking?.(true);
        setCandSpeaking?.(false);
        break;
      }


      case "output_audio_buffer.started": {
        console.log("[Realtime] 🔈 Assistant starts speaking");
        setIntvSpeaking?.(true);
        break;
      }

      case "output_audio_buffer.stopped": {
        setIntvSpeaking?.(false);
        break;
      }

      case "response.content_part.added": {
          break;
      }


      case "response.done": {
        setMessageItems((prev) =>
            prev.map((msg, i, arr) => {
              if (
                i === arr.length - 1 &&
                msg.role === "assistant" &&
                msg.streaming
              ) {
                return { ...msg, streaming: false };
              }
              return msg;
            })
        );
        break;
      }

  
      case "response.audio_transcript.delta": {
        const delta = event.delta || "";
        setMessageItems(prev => {
          const updated = [...prev];
      
          if (userTransDone) {
            if (pendingAIDeltas) {
              
              const textToAdd = pendingAIDeltas + delta;
              const last = updated[updated.length - 1];
              const isStreamingAssistant = last?.role === "assistant" && last?.streaming;
      
              if (isStreamingAssistant) {
                
                updated[updated.length - 1] = {
                  ...last,
                  text: last.text + textToAdd,
                };
              } else {
                updated.push({
                  role:      "assistant",
                  text:      textToAdd,
                  timestamp: new Date().toLocaleTimeString(),
                  streaming: true,
                });
              }
      
              pendingAIDeltas = "";  
            } else {
              
              const last = updated[updated.length - 1];
              const isStreamingAssistant = last?.role === "assistant" && last?.streaming;
      
              if (isStreamingAssistant) {
                updated[updated.length - 1] = {
                  ...last,
                  text: last.text + delta,
                };
              } else {
                updated.push({
                  role:      "assistant",
                  text:      delta,
                  timestamp: new Date().toLocaleTimeString(),
                  streaming: true,
                });
              }
            }
          } else {
            pendingAIDeltas += delta;
          }
      
          return updated;
        });
      
        break;
      }
      
      case "response.audio_transcript.done": {
        const transcript = event.transcript;
        updatePromptJson?.("assistant", transcript);
      }
  
      case "conversation.item.created": {
        console.log("[Realtime] 📥 Item created:", event);
        break;
      }
  
      case "conversation.item.input_audio_transcription.delta": {
        break;
      }

      case "conversation.item.input_audio_transcription.completed": {
        const text = event?.transcript;
        if (text) {
            setMessageItems((prev) => {
            const updated = [...prev];
            const last = updated[updated.length - 1];
            if (last && last.role === "user" && last.streaming) {
                last.text = text;
                last.streaming = false;
            }
            return updated;
            });
            userTransDone = true;
            updatePromptJson?.("user", text);
        }
        setCandSpeaking?.(false);
        break;
      }

      case "response.content_part.done": {
        console.log("[Realtime] ✅ Content part done");
        setCandSpeaking?.(false);
        break;
      }

  
      default:
        console.log("[Realtime] ℹ️ Unhandled event type:", event.type);
        break;
    }
  }